import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowLeft, ArrowRight } from "lucide-react";
import Reveal from "./Reveal";
import { testimonialsSection as T } from "../mock";

const Testimonials = () => {
  const [idx, setIdx] = useState(0);
  const [dir, setDir] = useState(1);
  const total = T.items.length;

  const go = (d) => {
    setDir(d);
    setIdx((p) => (p + d + total) % total);
  };

  const item = T.items[idx];

  return (
    <section className="relative bg-[#0b0b0b] text-white py-24 md:py-32 px-5 overflow-hidden">
      <div className="max-w-[1240px] mx-auto">
        <Reveal>
          <p className="text-center text-[#8a8a8a] text-sm mb-4">{T.eyebrow}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-cal text-center text-[64px] md:text-[130px] leading-none text-white/95">
            {T.title}
          </h2>
        </Reveal>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16 border-y border-white/10 py-12">
          {T.stats.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.1}>
              <div className="text-center">
                <div className="font-cal text-5xl md:text-6xl text-[#ff4d17]">{s.value}</div>
                <div className="text-[#9a9a9a] mt-2">{s.label}</div>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Carousel */}
        <div className="mt-16 grid md:grid-cols-2 gap-10 items-center">
          <div className="relative h-[300px] md:h-[420px] rounded-3xl overflow-hidden">
            <AnimatePresence mode="wait" custom={dir}>
              <motion.img
                key={idx}
                src={item.image}
                alt={item.name}
                initial={{ opacity: 0, scale: 1.05 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
                className="absolute inset-0 w-full h-full object-cover"
              />
            </AnimatePresence>
          </div>

          <div>
            <div className="text-[#8a8a8a] text-sm mb-6">
              0{idx + 1} <span className="mx-1">/</span> 0{total}
            </div>
            <AnimatePresence mode="wait">
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.4 }}
              >
                <p className="font-cal text-2xl md:text-4xl leading-snug">“{item.quote}”</p>
                <div className="mt-8">
                  <div className="text-lg font-medium">{item.name}</div>
                  <div className="text-[#8a8a8a]">{item.role}</div>
                </div>
              </motion.div>
            </AnimatePresence>

            <div className="flex gap-3 mt-10">
              <button
                onClick={() => go(-1)}
                className="w-12 h-12 rounded-full border border-white/20 flex items-center justify-center hover:bg-[#ff4d17] hover:border-[#ff4d17] transition-colors"
              >
                <ArrowLeft size={18} />
              </button>
              <button
                onClick={() => go(1)}
                className="w-12 h-12 rounded-full border border-white/20 flex items-center justify-center hover:bg-[#ff4d17] hover:border-[#ff4d17] transition-colors"
              >
                <ArrowRight size={18} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
